module.exports = __webpack_public_path__ + "static/media/ControlGuide_ch_phone.e6ca459d.png";